import React from 'react';
import CashOnDelivery from './CashOnDelivery';
import CommonBadge from './CommonBadge';
import DiscountBadge from './DiscountBadge';
import DiscountOfferBadge from './DiscountOfferBadge';
import EMI from './EMI';
import FreeDelivery from './FreeDelivery';
import FreeInstallation from './FreeInstallation';
import HotBadgeV2 from './HotBadgeV2';
import ImagePlaceholderBadge from './ImagePlaceholderBadge';
import MegaDeal from './MegaDeal';
import New from './New';
import Pay from './Pay';
import StoreLocator from './StoreLocator';
import TextBadge from './TextBadge';

function Badge(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'free-delivery':
      return <FreeDelivery {...rest} />;
    case 'emi':
      return <EMI {...rest} />;
    case 'pay':
      return <Pay {...rest} />;
    case 'cash-on-delivery':
      return <CashOnDelivery {...rest} />;
    case 'free-installation':
      return <FreeInstallation {...rest} />;

    case 'mega_deal':
      return <MegaDeal {...rest} />;
    case 'new':
      return <New {...rest} />;
    case 'placeholder':
      return <ImagePlaceholderBadge {...rest} />;
    case 'hot':
      return <HotBadgeV2 {...rest} />;
    case 'text':
      return <TextBadge {...rest} />;

    case 'store-locator':
      return <StoreLocator {...rest} />;
    case 'hot-offer-badge':
      return <HotBadgeV2 {...rest} />;
    case 'image-placeholder-badge':
      return <ImagePlaceholderBadge {...rest} />;
    case 'discount-badge':
      return <DiscountBadge {...rest} />;
    case 'common-badge':
      return <CommonBadge {...rest} />;
    case 'discount-offer-badge':
      return <DiscountOfferBadge {...rest} />;
    default:
      return '';
  }
}

export default Badge;
